import tryParseJson from 'data/services/string/parseJson';

const mapLLMValues = (values: Record<string, unknown>) => {
    const {
        tools, useInputSchema, inputSchema, outputSchema, jsonMode, ...rest
    } = values;

    const result: Record<string, unknown> = {
        jsonMode, ...rest, generation: values.generation || {},
    };

    if (tools !== undefined) {
        result.tools = typeof tools === 'string' ? tryParseJson(tools) : tools;
    }

    result.inputSchema = typeof inputSchema === 'string' ? tryParseJson(inputSchema) : inputSchema;

    if (jsonMode) {
        result.outputSchema = typeof outputSchema === 'string' ? tryParseJson(outputSchema) : outputSchema;
    }

    return result;
};

export default mapLLMValues;
